var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Code } from '../code';
import { CopyButton } from '../copy-button';
import { styled } from '../styled';
import { Text } from '../text';
var descriptionBlockComponentName = 'QuantumDescriptionBlock';
export var Root = styled('div', {
    name: descriptionBlockComponentName,
    slot: 'Root',
})(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    var isInlinelayout = ownerState.layout === 'inline';
    return {
        display: 'grid',
        gridTemplateColumns: !ownerState.label ? 'auto' : isInlinelayout ? 'max-content auto' : 'minmax(0, 1fr)',
        gridGap: isInlinelayout ? theme.spacing(1) : theme.spacing(0.5),
        alignItems: isInlinelayout ? 'center' : '',
    };
});
var Content = styled('div', {
    name: descriptionBlockComponentName,
    slot: 'Content',
})({
    display: 'flex',
    alignItems: 'center',
});
var CopyAction = styled(CopyButton, {
    name: descriptionBlockComponentName,
    slot: 'CopyAction',
})(function (_a) {
    var theme = _a.theme;
    return ({
        height: '1em',
        width: '1em',
        padding: 0,
        marginLeft: theme.spacing(1),
    });
});
export var DescriptionBlock = React.forwardRef(function (props, ref) {
    var label = props.label, description = props.description, code = props.code, onCopy = props.onCopy, _a = props.layout, layout = _a === void 0 ? 'default' : _a, _b = props.labelTypographyProps, labelTypographyProps = _b === void 0 ? {} : _b, _c = props.descriptionTypographyProps, descriptionTypographyProps = _c === void 0 ? {} : _c, rootProps = __rest(props, ["label", "description", "code", "onCopy", "layout", "labelTypographyProps", "descriptionTypographyProps"]);
    var inlinelayout = layout === 'inline';
    return (React.createElement(Root, __assign({ ref: ref, ownerState: { layout: layout, label: label } }, rootProps),
        !!label && (React.createElement(Text, __assign({ component: "span", variant: "body2", color: "textSecondary" }, labelTypographyProps),
            label,
            !!label && inlinelayout && ':')),
        React.createElement(Content, null,
            code ? (React.createElement(Code, __assign({ title: typeof description === 'string' ? description : undefined, sx: { maxWidth: 300 }, variant: "code2", noWrap: true }, descriptionTypographyProps), description)) : (React.createElement(Text, __assign({ component: "span", variant: "body2" }, descriptionTypographyProps), description)),
            !!onCopy && React.createElement(CopyAction, { size: "small", onClick: onCopy }))));
});
